// src/Pages/Reminder.js
import React, { useState, useEffect } from 'react';
// 引入 useTranslation Hook
import { useTranslation } from 'react-i18next';
import { FaSyncAlt } from 'react-icons/fa';

function Reminder() {
  // 加入多語言 Hook
  const { t } = useTranslation();

  const [showModal, setShowModal] = useState(false);
  const [activeReminder, setActiveReminder] = useState(null);

  const fixedReminder = t('reminderContent');
  const translatedReminders = t('reminderRandomContent', {
    returnObjects: true,
    defaultValue: [],
  });
  const randomReminders = Array.isArray(translatedReminders)
    ? translatedReminders
    : [];
  const displayedReminder = activeReminder || fixedReminder;

  const getAvailableReminders = () => {
    const reminderPool = [...new Set([fixedReminder, ...randomReminders])];
    return reminderPool.filter((reminder) => reminder !== displayedReminder);
  };

  const availableReminders = getAvailableReminders();
  const canCycleReminder = availableReminders.length > 0;

  // 若 24 小時內已關閉過，不再彈出
  useEffect(() => {
    const lastSeen = localStorage.getItem('welcomeLastSeen');
    const TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000;
    if (!lastSeen || Date.now() - Number(lastSeen) > TWENTY_FOUR_HOURS) {
      setShowModal(true);
    }
  }, []);

  const handleCloseModal = () => {
    localStorage.setItem('welcomeLastSeen', String(Date.now()));
    setShowModal(false);
  };

  const handleChangeReminder = () => {
    if (availableReminders.length === 0) {
      return;
    }

    const nextReminder =
      availableReminders[Math.floor(Math.random() * availableReminders.length)];
    setActiveReminder(nextReminder);
  };

  if (!showModal) {
    return null;
  }

  return (
    <div className="overlay">
      <div className="overlay-content">
        <div className="reminder-quote-row">
          <p className="reminder-hero">{displayedReminder}</p>
          <button
            type="button"
            className="reminder-cycle-button"
            onClick={handleChangeReminder}
            disabled={!canCycleReminder}
            aria-label={t('reminderCycleLabel')}
            title={t('reminderCycleLabel')}
          >
            <FaSyncAlt aria-hidden="true" />
          </button>
        </div>
        <button className="reminder-button" onClick={handleCloseModal}>
          {t('reminderButton')}
        </button>
      </div>
    </div>
  );
}

export default Reminder;
